export const QUERY_LISTING_COLUMNS = [
  {
    id: "queryId",
    label: "Query Id",
  },
  {
    id: "queryType",
    label: "Query Type",
  },
  {
    id: "queryTypeSubtype",
    label: "Query TypeSubtype",
  },

  {
    id: "commentBox",
    label: "Comment Box",
  },
  {
    id: "status",
    label: "Status",
  },

  {
    id: "actions",
    label: "Actions",
  },
];

export const QUERY_DETAILS_COLUMNS = [
  {
    id: "queryId",
    label: "QueryId",
  },
  {
    id: "queryType",
    label: "Query Type",
  },
  {
    id: "queryTypeSubtype",
    label: "Query TypeSubtype",
  },
  {
    id: "commentThread",
    label: "Comment Thread",
  },
  {
    id: "commentBox",
    label: "Comment Box",
  },
  {
    id: "status",
    label: "Status",
  },
];
